import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const stylepacksSlice = createAppSlice({
  name: 'stylepacks',
  initialState,
  reducers,
});

export default stylepacksSlice.reducer;

export const { loadStylepacks } = stylepacksSlice.actions;
